








import Component from "vue-class-component";
import ProgressSpinner from "../../general/component/spinner/ProgressSpinner.vue";
import Vue from "vue";

@Component({
  components: { ProgressSpinner }
})
export default class ProgressSpinnerWrapper extends Vue {}
